/*eslint-disable*/
import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components

import styles from "assets/jss/material-kit-react/views/landingPageSections/dudeStyle.js";

const useStyles = makeStyles(styles);

export default function Dude(props) {
  const classes = useStyles();
  return (
    <div className={classes.parentC}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.8523 222.5376" width={'80%'} height={'80%'}>
        <line x1="32.4041" y1="156.7001" x2="32.4041" y2="215.1001" className={classes.st0}/>
        
        <path d="M36.7,217.5l-3.6-2.1a2.1121,2.1121,0,0,1-.8-2.8l.1-.1a2.1121,2.1121,0,0,1,2.8-.8l3.6,2.1a2.1121,2.1121,0,0,1,.8,2.8l-.1.1A2.0852,2.0852,0,0,1,36.7,217.5Z" transform="translate(0.0041 1.3001)" className={classes.st1}/>
        
        <line x1="71.9041" y1="158.0001" x2="71.9041" y2="213.0001" className={classes.st0}/>

        <path d="M75.9,217.1l-4.4-2.5a2.1121,2.1121,0,0,1-.8-2.8l.1-.1a2.1121,2.1121,0,0,1,2.8-.8l4.4,2.5a2.1121,2.1121,0,0,1,.8,2.8l-.1.1A1.9275,1.9275,0,0,1,75.9,217.1Z" transform="translate(0.0041 1.3001)" className={classes.st1}/>

        {/* Back arm lower*/}
        <path d="M107.8,136.6a3.9009,3.9009,0,0,1-3.4-1.9L88.8,108.8a4.0131,4.0131,0,0,1,6.9-4.1l15.6,26a4.04,4.04,0,0,1-1.4,5.5A7.7891,7.7891,0,0,1,107.8,136.6Z" transform="translate(0.0041 1.3001)" className={classes.st8}/>

        {/* Back arm upper*/}
        <path d="M92.2,110.7a3.9009,3.9009,0,0,1-3.4-1.9l-16.2-27a4.0131,4.0131,0,0,1,6.9-4.1l16.2,27a4.04,4.04,0,0,1-1.4,5.5A5.3742,5.3742,0,0,1,92.2,110.7Z" transform="translate(0.0041 1.3001)" className={classes.st8}/>

        {/* body */}
        <path d="M64.8,54.9C96.2,77.6,114.1,141,76.3,166.6,45,189.2-.5,165.4,0,123.5.4,97.1,15.7,65.3,34.1,54.2c8.2-5.9,22.2-5.8,30.7.7" transform="translate(0.0041 1.3001)" className={classes.st9}/>

        {/* head */}
        <path d="M60.5,20.3c-4.8,2.1-9.8,1-11.7.6-5.6-1.2-6.3-3.5-8.8-2.9-5.3,1.3-5.8,12.4-8.8,12.3-2.5,0-3.8-7.3-5.3-7-.8.1-.7,2.3-1.6,6.2-.8,3.5-2.3,8-3.1,7.9-1.1-.1,0-10.9-1.6-11.2s-4.5,9.1-5.8,8.8v5.1A24.3187,24.3187,0,0,0,25.1,60.4a36.2615,36.2615,0,0,0,19.2,6H46a40.4549,40.4549,0,0,0,18.4-4.3c9.1-4.7,14.2-12.6,14.4-22.2V27.3a.0979.0979,0,0,0-.1.1c-1.3.4-5.1-10.5-10.2-11.7a3.4019,3.4019,0,0,0-1-.1C64.9,15.7,64.9,18.4,60.5,20.3ZM51.2,54.7a16.7165,16.7165,0,0,1-11.3-4l1.4-1.4s3.4,3.4,9.9,3.4c7.1,0,9.7-3.2,9.8-3.3l1.6,1.2C62.5,50.8,59.4,54.7,51.2,54.7Z" transform="translate(0.0041 1.3001)" className={classes.st8}/>

        {/* hair */}
        <path d="M77.1,17.2C72.9,7.9,62,1,50.1-.9,29.6-4,15.2,11.5,13.8,25.3c-.4,4.2-1,9.5,0,9.7,1.3.3,4.2-9.1,5.8-8.8s.5,11.1,1.6,11.2c.8.1,2.3-4.4,3.1-7.9.9-3.9.8-6.1,1.6-6.2,1.5-.3,2.8,7,5.3,7,3,.1,3.5-11,8.8-12.3,2.5-.6,3.2,1.7,8.8,2.9,1.9.4,6.9,1.5,11.7-.6,4.4-1.9,4.4-4.6,7-4.7a3.4019,3.4019,0,0,1,1,.1c5.1,1.2,8.9,12.1,10.2,11.6a.0979.0979,0,0,0,.1-.1C79.7,26.8,79.2,21.9,77.1,17.2Z" transform="translate(0.0041 1.3001)" className={classes.st6}/>
        
        {/* mouth */}
        <path d="M51.2,52.7a15.1447,15.1447,0,0,1-9.9-3.4l-1.4,1.4c.2.2,4,4,11.3,4,8.2,0,11.2-3.9,11.4-4.1L61,49.4C60.9,49.5,58.4,52.7,51.2,52.7Z" transform="translate(0.0041 1.3001)" className={classes.st7}/>

        {/* Front Upper arm */}
        <path d="M30.2,121.9a4.036,4.036,0,0,1-3.7-2.4L16.7,96.6A3.9655,3.9655,0,0,1,24,93.5l9.8,22.9a3.9288,3.9288,0,0,1-2.1,5.2A3.6532,3.6532,0,0,1,30.2,121.9Z" transform="translate(0.0041 1.3001)" className={classes.st8}/>

        {/* Front Lower arm */}        
        <path d="M54,138.4a3.891,3.891,0,0,1-2.3-.7L27.9,121.2a4.0224,4.0224,0,1,1,4.6-6.6l23.8,16.5a4.0084,4.0084,0,0,1,1,5.6A3.9017,3.9017,0,0,1,54,138.4Z" transform="translate(0.0041 1.3001)" className={classes.st8}/>
      </svg>
    </div>


  );
}
